"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  "Add a custom color": "カスタム色を追加",
  Apply: "適用",
  "Apply color": "色を適用",
  Automatic: "自動",
  Cancel: "キャンセル",
  "Cancel color": "色をキャンセル",
  Change: "変更",
  Custom: "カスタム",
  "Custom color picker": "カスタム色ピッカー",
  "Invalid hex value": "無効な 16 進数値です",
  Remove: "削除",
  "Select color {color}": ["色 ", ["color"], " を選択"],
  "You’ve reached the {maxCustomColors} custom colors limit. To add another color, remove one first.": ["カスタム色の上限数 (", ["maxCustomColors"], ") に達しました。 別の色を追加するには、まずいずれかの色を削除してください。"]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map